import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Methodology from "@/pages/Methodology";
import TheWork from "@/pages/TheWork";
import FinalTribute from "@/pages/FinalTribute";
import About from "@/pages/About";
import Commission from "@/pages/Commission";
import Faq from "@/pages/Faq";
import FromThePage from "@/pages/FromThePage";
import FromTheBooklet from "@/pages/FromTheBooklet";
import Book from "@/pages/Book";
import BookCheckout from "@/pages/BookCheckout";
import BookEbookCheckout from "@/pages/BookEbookCheckout";
import BookThankYou from "@/pages/BookThankYou";
import AdminLogin from "@/pages/AdminLogin";
import AdminEnquiries from "@/pages/AdminEnquiries";
import AdminStudio from "@/pages/AdminStudio";
import AdminDocuments from "@/pages/AdminDocuments";
import AdminSignatures from "@/pages/AdminSignatures";
import AdminBook from "@/pages/AdminBook";
import SignDocument from "@/pages/SignDocument";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/the-method" element={<Methodology />} />
            <Route path="/the-work" element={<TheWork />} />
            <Route path="/final-tribute" element={<FinalTribute />} />
            <Route path="/principles" element={<Navigate to="/commission" replace />} />
            <Route path="/the-anthropologist" element={<About />} />
            <Route path="/commission" element={<Commission />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/from-the-page" element={<FromThePage />} />
            <Route path="/from-the-booklet" element={<FromTheBooklet />} />
          </Route>
          <Route path="/no-one-is-coming" element={<Book />} />
          <Route path="/no-one-is-coming/checkout" element={<BookCheckout />} />
          <Route path="/no-one-is-coming/ebook-checkout" element={<BookEbookCheckout />} />
          <Route path="/no-one-is-coming/thank-you" element={<BookThankYou />} />
          {/* keep old /book links working */}
          <Route path="/book" element={<Navigate to="/no-one-is-coming" replace />} />
          <Route path="/book/checkout" element={<Navigate to="/no-one-is-coming/checkout" replace />} />
          <Route path="/book/thank-you" element={<Navigate to="/no-one-is-coming/thank-you" replace />} />
          <Route path="/sign/:token" element={<SignDocument />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/enquiries" element={<AdminEnquiries />} />
          <Route path="/admin/studio" element={<AdminStudio />} />
          <Route path="/admin/documents" element={<AdminDocuments />} />
          <Route path="/admin/signatures" element={<AdminSignatures />} />
          <Route path="/admin/book" element={<AdminBook />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
